import { Link } from 'react-router-dom';
import {Card, CardBody, Col, Container, Row } from 'reactstrap';
import BannerStatusIndexDataTable from './components/BannerStatusIndexDataTable';

const BannerStatusIndex = () => {
  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">All System Status Banner</h3>
          <h3 className="page-subhead subhead"><Link className="" to="/">Home</Link> / System Status Banner</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
            <Card>
                <CardBody>
                    <BannerStatusIndexDataTable />
                </CardBody>
            </Card>
        </Col>
      </Row>
    </Container>
)}

export default BannerStatusIndex;
